export default {
    
    loader: [],

};
